import {
    IQueryContext,
    IQueryContextDatasourceColumnState,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    DashboardItemComponentType,
    DashboardItemFactory,
    IDatasourceColumnDashboardItem,
} from 'src/app/utils/dashboard-item';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import { pivotTable } from 'src/app/utils/pivot';

export interface ISegmentsData {
    value: string[];
}

export interface ISegmentDatasourceColumnState extends IQueryContextDatasourceColumnState {
    value: {
        options: any[];
        operator: 'OR' | 'AND';
    };
    isExcludeApplied?: boolean;
}

export interface ISegmentsDatasourceColumnDashboardItem extends IDatasourceColumnDashboardItem {
    datasourceColumn: {
        id: DatasourceColumnId;
        state: ISegmentDatasourceColumnState;
    };
    // override default return value of composeData function
    composeData: (a: any[], b?: IQueryContext) => ISegmentsData;
    /** If provided, segment dashboard item will show additional
     * select component to choose reference segment for uplift calculations */
    upliftReferenceSegmentSettingId?: QueryContextSettingID;
    /** Use if you want to exclude segments **/
    excludeMode?: boolean;
    /** If true, will show link to create new segment */
    showNewSegmentLink: boolean;
}

export interface SegmentsDashboardItemFactoryOptions {
    createdInstanceId: string;
    /** Datasource column id for segment filter. @default 'SEGMENT' */
    datasourceColumnId?: DatasourceColumnId;
    /** If provided, segment dashboard item will show additional
     * select component to choose reference segment for uplift calculations */
    upliftReferenceSegmentSettingId?: QueryContextSettingID;
    /** Use if you want to exclude segments **/
    excludeMode?: boolean;
    /** If true, will show link to create new segment
     * @default true
     */
    showNewSegmentLink?: boolean;
}

export class SegmentsDashboardItemFactory extends DashboardItemFactory<
    ISegmentsDatasourceColumnDashboardItem,
    SegmentsDashboardItemFactoryOptions
> {
    override FACTORY_CLASS: string = 'SegmentsDashboardItemFactory';
    override COMPONENT_CLASS: DashboardItemComponentType =
        'SegmentsFilterDashboardItem';

    override getInstance(
        options: SegmentsDashboardItemFactoryOptions
    ): ISegmentsDatasourceColumnDashboardItem {
        const datasourceColumnId = options.datasourceColumnId ?? 'SEGMENT';
        const instance: ISegmentsDatasourceColumnDashboardItem = {
            datasourceColumnId: datasourceColumnId,
            datasourceColumn: {
                id: datasourceColumnId,
                state: {
                    value: {
                        options: [],
                        operator: 'OR',
                    },
                    isFilterApplied: false,
                    isSplitApplied: false,
                },
            },
            instanceId: options.createdInstanceId,
            dashboardItem: {
                id: options.datasourceColumnId,
                initialState: {
                    value: [],
                    split: false,
                    isFilterApplied: false,
                    isSplitApplied: false,
                },
            },
            component: this.COMPONENT_CLASS,
            composeData: (data: any[], context?: IQueryContext) => {
                const pivotResult = pivotTable<any>(data);
                console.log({
                    msg: `[ISegmentsDatasourceColumnDashboardItem.composeData] pivotResult`,
                    pivotResult,
                });
                const selectOptions =
                    pivotResult[datasourceColumnId.replace('.', '_')];
                return { value: selectOptions };
            },
            upliftReferenceSegmentSettingId:
                options.upliftReferenceSegmentSettingId,
            excludeMode: options.excludeMode,
            showNewSegmentLink: options.showNewSegmentLink ?? true,
        };

        return instance;
    }
}
